// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { withdrawConnectedApplication } from '@/account/api/withdraw-connected-application';
import { CONNECTED_APPLICATIONS_QUERY_KEY } from '@/account/constants/connected-applications';
import { useMutationWithGlobalErrorHandler } from '@/hooks/use-mutation-with-global-error-handler';
import { useQueryClient } from '@tanstack/react-query';

/** Disconnects an application and shows the list of connected applications it answers with. */
export function useWithdrawConnectedApplication() {
  const queryClient = useQueryClient();

  return useMutationWithGlobalErrorHandler({
    mutationFn: (key: string) => withdrawConnectedApplication(key),
    errorMessage: 'The application could not be disconnected.',
    onSuccess: (response) => {
      queryClient.setQueryData(CONNECTED_APPLICATIONS_QUERY_KEY, response);
    },
  });
}
